import { callUnaryMethod, useTransport } from "@connectrpc/connect-query";
import { useQuery } from "@tanstack/react-query";
import { NPSService } from "@viajero/proto/guest/v1";
import { getNPSToken } from "@/lib/npsToken";

/**
 * NPSService.GetNPSContext を connect-query の transport でラップするフック。
 *
 * アンケート画面 (/nps/{npsToken}) の表示に必要な予約情報と回答済みフラグを取得する。
 * `x-nps-token` ヘッダは lib/client.ts の npsTokenInterceptor が付与するため、呼び出し側は
 * リクエストパラメータを意識しなくてよい (§6.7)。ただしリクエストが空メッセージのため、
 * connect-query 標準の useQuery だと queryKey がリクエスト内容だけで決まり npsToken を
 * 区別できない。トークンごとにキャッシュを分離するため queryKey に npsToken を含める
 * (useGetReservation.ts と同方式)。
 */
export function useGetNPSContext() {
  const transport = useTransport();
  const npsToken = getNPSToken();
  return useQuery({
    queryKey: ["npsContext", npsToken],
    queryFn: ({ signal }) =>
      callUnaryMethod(transport, NPSService.method.getNPSContext, {}, { signal }),
  });
}
